import { DateTime } from 'luxon';

import { APIConfig } from 'src/config';

/**
 * Builds reset variables for retrying the `TradeRuleProposeNominatedRoute_Query`.
 * The GraphQL query accepts `$uuid: ID!` and `$now: Timestamp!`. On retry, `now` is
 * recomputed in the partner's default timezone (mirroring `prepareVariables` in
 * `src/routes/index.jsx`) so the residual-rules window used by the time-of-use pricing
 * form reflects the moment of the retry, not the original page load.
 * @param {object} props - Route props provided by found-relay.
 * @param {object} props.match - The matched route object.
 * @param {object} props.match.params - URL parameters extracted from the matched route.
 * @param {string} props.match.params.uuid - The property UUID from the route path
 * (e.g. `/properties/:uuid/trade-rules/propose/nominated`).
 * @returns {{uuid: string, now: number}|null} Retry variables, or `null` if the `uuid`
 *   parameter is missing.
 */
function buildTradeRuleProposeNominatedRetryVariables(props) {
  const routeUuid = props?.match?.params?.uuid;

  if (!routeUuid) {
    return null;
  }

  const timezone = APIConfig().DEFAULT_TIMEZONE;

  return {
    uuid: routeUuid,
    now: Math.floor(DateTime.local({ zone: timezone }).toSeconds()),
  };
}

export default buildTradeRuleProposeNominatedRetryVariables;
